var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconRechnung(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 28,
    viewBox: "0 0 24 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.a,.b{stroke:#124395;stroke-width:2px;}.b,.d{fill:none;}.b{stroke-linecap:round;}.c{stroke:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-784 -847)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(784 847)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 24,
    height: 28,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    x: 1,
    y: 1,
    width: 22,
    height: 26,
    rx: 1
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-29.386 -22.949)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 2.609)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M8532.846,16401.84h4.2",
    transform: "translate(-7715 -15512)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M8540.563,16401.84h7.365",
    transform: "translate(-7715 -15512)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 3.609)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M8532.846,16401.84h4.2",
    transform: "translate(-7715 -15518)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M8540.563,16401.84h7.365",
    transform: "translate(-7715 -15518)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 1.609)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M8532.846,16401.84h4.2",
    transform: "translate(-7715 -15521)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M8540.563,16401.84h7.365",
    transform: "translate(-7715 -15521)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M8502.845,16396.449h15.082",
    transform: "translate(-7685 -15521)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRechnung);
export default __webpack_public_path__ + "static/media/icon-rechnung.8911f052589a9959701a33dcab0c61a3.svg";
export { ForwardRef as ReactComponent };